import styled from 'styled-components';

export const ResponsiveSearchDrawerItemContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  height: fit-content;

  div:last-child {
    border-right: none;
  }
`;
